import { configureStore } from '@reduxjs/toolkit';
import authReducer         from './slices/authSlice';
import appointmentReducer  from './slices/appointmentSlice';
import clientReducer       from './slices/clientSlice';
import invoiceReducer      from './slices/invoiceSlice';
import uiReducer           from './slices/uiSlice';
import settingsReducer     from './slices/settingsSlice';
import staffReducer        from './slices/staffSlice';
import inventoryReducer    from './slices/inventorySlice';
import membershipReducer   from './slices/membershipSlice';
import packageReducer      from './slices/packageSlice';
import leadsReducer        from './slices/leadsSlice';
import marketingReducer    from './slices/marketingSlice';
import loyaltyReducer     from './slices/loyaltySlice';

export const store = configureStore({
  reducer: {
    auth:         authReducer,
    appointments: appointmentReducer,
    clients:      clientReducer,
    invoices:     invoiceReducer,
    ui:           uiReducer,
    settings:     settingsReducer,
    staff:        staffReducer,
    inventory:    inventoryReducer,
    membership:   membershipReducer,
    packages:     packageReducer,
    leads:        leadsReducer,
    marketing:    marketingReducer,
    loyalty:      loyaltyReducer,
  },
});

export type RootState   = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
